import { ItemTypeConsts } from 'client/util/Constants';

export default function (path) {
  const { application, sso } = ItemTypeConsts;
  const page = path.split('/')[0];
  return page === sso ? sso : application;
}
